import React, { Component } from 'react';
import {
    Paper,
    Grid,
    Dialog,
    DialogContent,
    DialogActions,
    Switch,
    FormControlLabel,
    TextField,
    Typography,
    Chip,
    Divider,
    Button,
} from '@material-ui/core';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import EditIcon from '@material-ui/icons/Edit';
import AppBarModal from '../../../general/AppBarModal';
import { BtnForm } from '../../../general/BotonesAccion';
import TareasTerminadas from '../../../general/TareasTerminadas';
import emma_w from '../../../../global/imagenes/emma_w.png';
import { coloresEmma } from '../../../../global/js/funciones';
import {
    DIAS_SEMANA,
    HORA_INICIO_SUGERIDA,
    HORA_FIN_SUGERIDA,
    tieneHorarioConfigurado,
    normalizarDias,
    validarDias,
    construirPayloadHorario,
} from '../helpers/horarioBienestarUtils';
import {
    fetchHorarioAtencion,
    postHorarioAtencion,
} from '../services/bienestarAdministrarService';
import SemanaHorario from './SemanaHorario';


/**
 * Horario de recepción de solicitudes: tarjeta fija en la pestaña Administrar
 * y diálogo de edición de la semana completa.
 */
class HorarioAtencionBienestar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            cargando: true,
            guardando: false,
            modal: false,
            horario: null,
            dias: normalizarDias([]),
            restriccion_activa: false,
            linea_atencion: '',
            errores: {},
            errorCarga: false,
        };
    }

    componentDidMount() {
        this.cargarHorario();
    }

    cargarHorario = async () => {
        this.setState({ cargando: true });
        const horario = await fetchHorarioAtencion();
        this.setState({ horario, errorCarga: horario === null, cargando: false });
    };

    abrirModal = () => {
        const { horario } = this.state;
        this.setState({
            modal: true,
            errores: {},
            dias: normalizarDias(horario ? horario.dias : []),
            restriccion_activa: Boolean(horario && horario.restriccion_activa),
            linea_atencion: (horario && horario.linea_atencion) || '',
        });
    };

    cerrarModal = () => this.setState({ modal: false, errores: {} });

    cambiarDia = (diaSemana, cambios) => {
        this.setState((prev) => ({
            dias: prev.dias.map((dia) => (
                dia.dia_semana === diaSemana ? { ...dia, ...cambios } : dia
            )),
            errores: { ...prev.errores, [diaSemana]: undefined, general: undefined },
        }));
    };

    alternarDia = (diaSemana, abierto) => {
        const cambios = abierto
            ? { abierto: true }
            : { abierto: false };
        if (abierto) {
            const dia = this.state.dias.find((d) => d.dia_semana === diaSemana) || {};
            cambios.hora_inicio = dia.hora_inicio || HORA_INICIO_SUGERIDA;
            cambios.hora_fin = dia.hora_fin || HORA_FIN_SUGERIDA;
        }
        this.cambiarDia(diaSemana, cambios);
    };

    guardar = async () => {
        const { dias, restriccion_activa, linea_atencion } = this.state;
        const { actualizarMensaje } = this.props;

        const errores = validarDias(dias, restriccion_activa);
        if (Object.keys(errores).length > 0) {
            this.setState({ errores });
            return;
        }

        this.setState({ guardando: true });
        const payload = construirPayloadHorario(dias, restriccion_activa, linea_atencion);
        const { estado, resp } = await postHorarioAtencion(payload);
        this.setState({ guardando: false });

        if (estado === 200) {
            this.setState({ horario: resp, modal: false, errores: {} });
            if (actualizarMensaje) {
                actualizarMensaje({
                    titulo: resp.titulo || 'Horario actualizado correctamente',
                    tipo: 'success',
                    mostrar: true,
                    tiempo: 6000,
                });
            }
            return;
        }

        const detalle = (resp && (resp.titulo || resp.dias || resp.detail)) || 'Error al guardar el horario';
        if (actualizarMensaje) {
            actualizarMensaje({
                titulo: Array.isArray(detalle) ? detalle[0] : String(detalle),
                tipo: 'info',
                mostrar: true,
                tiempo: 6000,
            });
        }
    };

    pintarEstadoChip() {
        const { horario } = this.state;
        if (!horario || !horario.restriccion_activa) {
            return (
                <Chip
                    size="small"
                    label="Sin restricción"
                    style={{ backgroundColor: '#f0f0f0', color: '#616161', fontWeight: 500, height: 22 }}
                />
            );
        }
        const abierto = horario.abierto_ahora;
        return (
            <Chip
                size="small"
                label={abierto ? 'Abierto ahora' : 'Cerrado ahora'}
                style={{
                    backgroundColor: abierto ? '#e6f4ea' : '#fdecea',
                    color: abierto ? '#078030' : '#933b27',
                    fontWeight: 500,
                    height: 22,
                }}
            />
        );
    }

    pintarErrorCarga() {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 12,
            }}>
                <Typography variant="body2" style={{ color: '#933b27' }}>
                    No se pudo cargar el horario. Puede que el servicio no esté disponible en este momento.
                </Typography>
                <Button
                    size="small"
                    variant="outlined"
                    onClick={this.cargarHorario}
                    style={{
                        color: coloresEmma.primarycolor,
                        borderColor: coloresEmma.primarycolor,
                        textTransform: 'none',
                    }}
                >
                    Reintentar
                </Button>
            </div>
        );
    }

    pintarSinConfigurar() {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 12,
            }}>
                <Typography variant="body2" style={{ color: '#757575' }}>
                    Aún no se ha definido un horario. Por ahora se reciben solicitudes a cualquier hora.
                </Typography>
                <Button
                    size="small"
                    variant="outlined"
                    onClick={this.abrirModal}
                    style={{
                        color: coloresEmma.primarycolor,
                        borderColor: coloresEmma.primarycolor,
                        textTransform: 'none',
                    }}
                >
                    Configurar horario
                </Button>
            </div>
        );
    }

    pintarFormulario() {
        const { dias, restriccion_activa, linea_atencion, errores } = this.state;

        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={(
                            <Switch
                                checked={restriccion_activa}
                                onChange={(e) => this.setState({
                                    restriccion_activa: e.target.checked,
                                    errores: { ...errores, general: undefined },
                                })}
                                color="primary"
                            />
                        )}
                        label="Restringir la creación de solicitudes por horario"
                    />
                    <Typography variant="caption" display="block" style={{ color: '#757575', marginLeft: 46 }}>
                        Con esta opción apagada se reciben solicitudes a cualquier hora, como hasta ahora.
                    </Typography>
                    {errores.general && (
                        <Typography variant="caption" display="block" style={{ color: '#f44336', marginLeft: 46 }}>
                            {errores.general}
                        </Typography>
                    )}
                </Grid>

                <Grid item xs={12}><Divider /></Grid>

                {DIAS_SEMANA.map(({ valor, largo }) => {
                    const dia = dias[valor];
                    const error = errores[valor];
                    return (
                        <Grid item xs={12} key={valor}>
                            <Grid container spacing={1} alignItems="center">
                                <Grid item xs={12} sm={4}>
                                    <FormControlLabel
                                        control={(
                                            <Switch
                                                size="small"
                                                checked={dia.abierto}
                                                onChange={(e) => this.alternarDia(valor, e.target.checked)}
                                                color="primary"
                                            />
                                        )}
                                        label={<Typography variant="body2">{largo}</Typography>}
                                    />
                                </Grid>
                                <Grid item xs={6} sm={4}>
                                    <TextField
                                        fullWidth
                                        type="time"
                                        label="Inicio"
                                        size="small"
                                        disabled={!dia.abierto}
                                        value={dia.hora_inicio}
                                        onChange={(e) => this.cambiarDia(valor, { hora_inicio: e.target.value })}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ step: 300 }}
                                        error={Boolean(error)}
                                    />
                                </Grid>
                                <Grid item xs={6} sm={4}>
                                    <TextField
                                        fullWidth
                                        type="time"
                                        label="Cierre"
                                        size="small"
                                        disabled={!dia.abierto}
                                        value={dia.hora_fin}
                                        onChange={(e) => this.cambiarDia(valor, { hora_fin: e.target.value })}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ step: 300 }}
                                        error={Boolean(error)}
                                    />
                                </Grid>
                                {error && (
                                    <Grid item xs={12}>
                                        <Typography variant="caption" style={{ color: '#f44336' }}>
                                            {error}
                                        </Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    );
                })}

                <Grid item xs={12}><Divider /></Grid>

                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Línea de atención inmediata (opcional)"
                        placeholder="Ej: la línea 3013994949"
                        value={linea_atencion}
                        onChange={(e) => this.setState({ linea_atencion: e.target.value })}
                        inputProps={{ maxLength: 255 }}
                        helperText="Se muestra al final del mensaje que ve quien intenta crear una solicitud fuera de horario."
                    />
                </Grid>
            </Grid>
        );
    }

    render() {
        const { cargando, guardando, modal, horario, errorCarga } = this.state;

        if (cargando) {
            return (
                <Paper elevation={0} style={{ padding: 20, marginBottom: 16, border: '1px solid #e8e8e8', borderRadius: 6 }}>
                    <TareasTerminadas mensaje="Cargando horario..." marginTop="0" imagen={emma_w} widthImg="4%" />
                </Paper>
            );
        }

        const configurado = tieneHorarioConfigurado(horario ? horario.dias : []);

        return (
            <>
                <Paper
                    elevation={0}
                    style={{
                        padding: '16px 20px 18px',
                        marginBottom: 16,
                        border: '1px solid #e8e8e8',
                        borderRadius: 6,
                    }}
                >
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: 10,
                        marginBottom: configurado ? 14 : 10,
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <AccessTimeIcon style={{ color: coloresEmma.primarycolor, fontSize: 19 }} />
                            <Typography variant="subtitle2" style={{ fontWeight: 600, letterSpacing: '.01em' }}>
                                Horario de recepción de solicitudes
                            </Typography>
                            {!errorCarga && this.pintarEstadoChip()}
                        </div>
                        {configurado && !errorCarga && (
                            <Button
                                size="small"
                                startIcon={<EditIcon style={{ fontSize: 16 }} />}
                                onClick={this.abrirModal}
                                style={{ color: coloresEmma.primarycolor, textTransform: 'none' }}
                            >
                                Editar
                            </Button>
                        )}
                    </div>

                    {errorCarga
                        ? this.pintarErrorCarga()
                        : (configurado
                            ? <SemanaHorario dias={horario ? horario.dias : []} />
                            : this.pintarSinConfigurar())}

                    {!errorCarga && configurado && horario && horario.actualizado_por && (
                        <Typography variant="caption" display="block" style={{ color: '#bdbdbd', marginTop: 10 }}>
                            Actualizado por {horario.actualizado_por}
                        </Typography>
                    )}
                </Paper>

                <Dialog open={modal} fullWidth maxWidth="sm" onClose={this.cerrarModal}>
                    <AppBarModal
                        titulo="¡ Horario de atención !"
                        mostrarModal={this.cerrarModal}
                        accion={this.cerrarModal}
                        titulo_accion="CERRAR"
                    />
                    <DialogContent className="scroll" style={{ paddingTop: 16 }}>
                        {this.pintarFormulario()}
                    </DialogContent>
                    <DialogActions>
                        <BtnForm texto="CANCELAR" callback={this.cerrarModal} />
                        <BtnForm
                            texto={guardando ? 'GUARDANDO...' : 'GUARDAR'}
                            callback={guardando ? () => {} : this.guardar}
                        />
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}

export default HorarioAtencionBienestar;
